<mat-table
  (matSortChange)="sortChange($event)"
  matSort
  [dataSource]="dataSource.data"
  class="call-history-table">
  <ng-container matColumnDef="direction">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="direction-header">
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="direction-wrapper">
            <span class="material-icons"
                  [ngClass]="arrowIconDirector(element)"
                  *ngIf="element.direction">{{arrowIconDirector(element)}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="contactName">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'CALL_HISTORY.DETAILS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="details-wrapper"
              [class.call_missed]="isCallMissed(element)">
      <cc-flag-number-item
        [label]="getNamePhrase(element.contactName, element.contactSurname)"
        [number]="element.msisdn"
        [empty]="'UNKNOWN'"
        [routerLink]="['/contact-details/' + element.recordId + '/0']">
      </cc-flag-number-item>
      <cc-call-icon
        *ngIf="element.msisdn?.startsWith('+')"
        [number]="element.msisdn"
      ></cc-call-icon>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="callTime">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'CALL_HISTORY.TIME' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="date-wrapper">{{ formatDate(element.startDate) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="agentName">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'CALL_HISTORY.USER' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="agent-wrapper">
      <cc-flag-label-item
        [label]="getNamePhrase(element.agentName, element.agentSurname)"
        [number]="element.agentMsisdn"
        [numberLabel]="element.agentMsisdnLabel"
        [empty]="'UNASSIGNED'">
      </cc-flag-label-item>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="callLength">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'CALL_HISTORY.CALL_LENGTH' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span>{{ formatCallLength(element.lengthSeconds).minutes }}&nbsp;<span translate>MINUTES_SHORT</span>&nbsp;</span>
      <span>{{ formatCallLength(element.lengthSeconds).seconds }}&nbsp;<span translate>SECONDS_SHORT</span></span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="appType">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'CALL_HISTORY.CALL_MODE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ getCallingMode(element) | translate }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="detailsInfo" sticky>
    <mat-header-cell *matHeaderCellDef class="details-info-header">
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="details-info-wrapper">
      <span (click)="detailsClicked.emit(element.id)"
            [routerLink]="['/call-details', element.id]"
            class="material-icons info">info</span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
